export default "__VITE_ASSET__DDXJ6JeO__"